import React from 'react';
import LockSvg from '../../assets/Lock';
import InfoBox from '../infoBox/InfoBox';
import { useTranslation } from 'react-i18next';

interface IProps {
  consentText: string | null;
  consentDate: Date | undefined;
}

const IdCoTermsContent: React.FC<IProps> = (props: IProps) => {
  const { consentDate, consentText } = props;
  const { t } = useTranslation();
  return (
    <InfoBox icon={<LockSvg />} data-testid="idco-terms-container">
      <p className="sm:text-base text-sm text-primary-2">
        {t(
          `Atto will not be able to see any of your login information, you can revoke our access at any time via your banking app, or by returning to this portal.`
        )}{' '}
        {consentDate && (
          <>
            {t('Your consent will be valid until:')}{' '}
            <span className="font-bold">
              {consentDate.toLocaleDateString(navigator.language, {
                year: 'numeric',
                month: 'long',
                day: '2-digit'
              })}
              .
            </span>{' '}
          </>
        )}
        {t('None of this will affect your credit score.')}
      </p>
      {consentText && <p className="sm:text-base text-sm text-primary-2">{consentText}</p>}
    </InfoBox>
  );
};

export default IdCoTermsContent;
